import { Button } from '@material-ui/core';

import { useHighDemandBtn } from './useHighDemandBtn';
import makeClasses from './HighDemandBtn.style';

import type { ButtonProps } from '@material-ui/core/Button';
import type { SaturationStateProp } from '../../shared/models';

export function HighDemandBtn(props: HighDemandBtnProps) {
  const { onClick, isSingleStore = true } = props;

  const { text, variant } = useHighDemandBtn({
    isSingleStore,
    pureVariant: props.variant,
  });

  const classes = makeClasses({ variant });

  return (
    <Button
      size='large'
      type='button'
      variant='contained'
      onClick={onClick}
      disabled={variant === 'deactivated'}
      classes={{ contained: classes.btn }}
    >
      {text.status} {text.demandTimer}
    </Button>
  );
}

interface HighDemandBtnProps
  extends SaturationStateProp,
    Pick<ButtonProps, 'onClick'> {
  isSingleStore?: boolean;
}
